<template>
  <v-container class="pa-0" fluid>
    <v-row>
      <v-col cols="12" md="6" class="pt-6">
        <About />
      </v-col>
      <v-col cols="12" md="6" class="pt-6">
        <Base />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import About from "@/components/pricing/About.vue";
import Base from "@/components/pricing/Base.vue";

export default {
  data: () => ({}),
  components: {
    About,
    Base
  }
};
</script>